import { useEffect } from 'react';
import { useRefWithCurrentValue } from './useRefWithCurrentValue';

export function useEventListener(
  element: GlobalEventHandlers,
  type: string,
  eventListener: EventListenerOrEventListenerObject
): void {
  const eventListenerRef = useRefWithCurrentValue(eventListener);

  useEffect(() => {
    const callCallback = (event: Event): void => {
      if (typeof eventListenerRef.current === 'function') {
        eventListenerRef.current(event);
      } else {
        eventListenerRef.current.handleEvent(event);
      }
    };

    element.addEventListener(type, callCallback);

    return () => {
      element.removeEventListener(type, callCallback);
    };
  }, [element, type, eventListenerRef]);
}
